import React from 'react'

const StatisticsSkeleton = () => {
    return (
        <div className="bg-white rounded-[10px] min-h-[170px] max-h-[188px] p-6 animate-pulse">
            {/* Header section */}
            <div className="flex items-center justify-between">
                <div>
                    <div className="h-5 bg-lightBG rounded w-[250px] mb-2 opacity-50"></div>
                    <div className="h-4 bg-lightBG rounded w-[200px] opacity-50"></div>
                </div>
                <div className="rounded-[100px] bg-[#5E639B] h-[50px] w-[100px] opacity-50"></div>
            </div>

            {/* Statistics grid */}
            <div className="grid grid-cols-4 gap-1 mt-[30px]">
                {/* Generate 4 statistic placeholders */}
                {[...Array(4)].map((_, index) => (
                    <div key={index} className="flex gap-1 items-center">
                        {/* Donut chart placeholder */}
                        <div className="w-[56px] h-[56px] rounded-full border-4 border-lightBG bg-white opacity-50 flex items-center justify-center">
                            <div className="w-[40px] h-[40px] rounded-full bg-[#5E639B] opacity-50"></div>
                        </div>
                        {/* Text placeholder */}
                        <div className="h-4 bg-lightBG rounded w-[80%] opacity-50"></div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default StatisticsSkeleton
